import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "profileViewLink" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_4 = ["title"]
const _hoisted_5 = ["titleNOMOREUSED"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatUserPicture = _resolveComponent("FormatUserPicture")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      ($props.prefixTextDisplayedBeforeName && $props.prefixTextDisplayedBeforeName !=='')
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createTextVNode(_toDisplayString($props.prefixTextDisplayedBeforeName) + " ", 1),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      ($props.appBoss === true /*&& displayAppBoss === true*/)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "logoContainer",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.viewUserProfile($props.userId)), ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "logoProfileAppBoss logoProfile",
              title: $setup.t('appBossTitle')
            }, [
              _createVNode(_component_FormatUserPicture, {
                pUserPictureUrl: $setup.firebaseStorage.getLongBucketStorageUrlForProfile($props.profilePictureUrl,
            $props.userId)
              }, null, 8, ["pUserPictureUrl"])
            ], 8, _hoisted_4)
          ]))
        : ($props.appBoss === false /*&& displayWannaBeAppBoss === true*/)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "logoContainer",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.viewUserProfile($props.userId)), ["stop"]))
            }, [
              _createElementVNode("div", {
                class: "logoProfileAppBossGreenAndRedNOMOREUSED logoProfile",
                titleNOMOREUSED: $setup.t('userProfileWannaBeABossTitle')
              }, [
                _createVNode(_component_FormatUserPicture, {
                  pUserPictureUrl: $setup.firebaseStorage.getLongBucketStorageUrlForProfile($props.profilePictureUrl,
            $props.userId)
                }, null, 8, ["pUserPictureUrl"])
              ], 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.viewUserProfile($props.userId)), ["stop"])),
        title: ($props.userDisplayedDescription !== '') ? $props.userDisplayedDescription : $setup.t('openProfile')
      }, _toDisplayString($props.userDisplayedName), 9, _hoisted_6)
    ])
  ]))
}